<div *ngIf="loading" class="loading">
    <div class="d-flex h-100 w-100 flex-column justify-content-center align-items-center text-primary-dark">
        <img class="img img-fluid" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1675173013667boy%20with%20suitcase%20and%20door%20travel.png" alt="loading">
        <h5>Keep Calm!</h5>
        <h5>The Door to your Dreams Is Opening</h5>
    </div>
</div>

<div *ngIf="!loading" class="content-height">
    <div class="d-lg-block d-none">
        <div class="row h-100">
            <div class="col-6 image-section" *ngIf="step === 'defaultForm' || step === 'showForm' || step === 'showOtpForm'">
                <div class="container h-100">
                    <div *ngIf="!isPartnerLink" class="d-flex justify-content-center mb-2 py-4">
                        <img class="img img-fluid" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1674329951680Group.png" alt="Education Loan">
                    </div>

                    <div class="d-flex justify-content-center py-3 mt-1" *ngIf="isPartnerLink">
                        <!-- hidden partner logo src -->
                        <ng-container *ngIf="isPartnerLink && partnerLogo?.includes('public'); else privateLogo">
                            <img class="img img-fluid" width="150" [src]="partnerLogo" alt="Education Loan">
                        </ng-container>
                        <ng-template #privateLogo>
                            <fa-async-image [src]="partnerLogo" [width]="'150'" [alt]="'image'"></fa-async-image>
                        </ng-template>
                    </div>

                    <div class="text-center mb-4">
                        <h1 class="text-primary-dark">Your Go-to Study Abroad<br> Loan Expert</h1>
                    </div>

                    <div class="text-center mb-6">
                        <div class="marquee">
                            <div class="track d-flex justify-content-center align-items-center">
                                <div *ngFor="let bank of banks" class="d-flex justify-content-center align-items-center bankLogoDiv flex-column">
                                    <img class="bankLogo" [src]="bank.logo" [alt]="bank.name">
                                    <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715235236243Ellipse%20117.png" alt="shadow">
                                </div>
                            </div>
                        </div>

                        <div class="margin-top-custom">
                            <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715231460452Stand%201.png" alt="">
                        </div>
                    </div>

                    <div class="d-flex justify-content-between align-items-center mb-5">
                        <div class="d-flex justify-content-between align-items-center bank-info-bg">
                            <img class="img img-fluid" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718261469699Frame%20285%202%20%286%29.png" alt="">
                            <p class="p-1 m-0 mt-1">Interest rates starts at 9.25%</p>
                        </div>

                        <div class="d-flex justify-content-between align-items-center bank-info-bg">
                            <img class="img img-fluid" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718272515212Frame%20285%202%20%287%29.png" alt="">
                            <p class="p-1 m-0 mt-1">100% free for students</p>
                        </div>

                        <div class="d-flex justify-content-between align-items-center bank-info-bg">
                            <img class="img img-fluid" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718272571488Frame%20285%202%20%288%29.png" alt="">
                            <p class="p-1 m-0 mt-1">Trusted by 32,000+ students globally</p>
                        </div>
                    </div>

                    <div class="text-center">
                        <h2 class="text-primary-dark mb-4 fw-200">4 steps to find your best loan</h2>
                        <img class="img img-fluid" src="../../../../assets/logo/4steps.svg" alt="" fetchPriority="low">
                    </div>
                </div>
            </div>

            <div *ngIf="step === 'defaultForm'" class="col-6 position-relative mt-10">
                <div class="d-flex justify-content-center align-items-center flex-column w-75 position-absolute top-50 start-50 translate-middle">
                    <button (click)="showFormLayout()" class="btn bg-primary-apply px-8 py-2 mb-3 fw-bold w-100">Apply
                        Now</button>
                    <p class="text-dark cursor">Already Applied?
                        <span class="text-primary-dark mt-1 fw-bold" (click)="checkStatus()">Check
                            Status</span>
                    </p>
                </div>
            </div>

            <div *ngIf="step==='showForm'" class="col-6">
                <div class="mb-8 overflow-hidden">
                    <apnst-common-header [config]="configMobileNumberHeader" [showHeaderWeb]="true" (stepEmitted)="emitStep($event)"></apnst-common-header>
                </div>

                <div class="container layoutHeight d-flex justify-content-start flex-column">
                    <div class="mb-3">
                        <aerp-base-schema-form [model]="model" [dataProcessor]="dataProcessor.bind(this)" [dataModel]="dataModel" (onSubmit)="onSubmit($event)" [layout]="layout">
                        </aerp-base-schema-form>
                        <div *ngIf="triggerErrorMessageMobile" class="text-danger">
                            {{errorMessageMobile}}
                        </div>
                        <div *ngIf="triggerErrorMessage" class="text-danger">
                            {{errorMessage}}
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="step==='showOtpForm'" class="col-6">
                <div class="mb-8 overflow-hidden">
                    <apnst-common-header [config]="configOTPHeader" [showHeaderWeb]="true" (stepEmitted)="emitStep($event)"></apnst-common-header>
                </div>
                <ng-container *ngIf="otpModel && otpFields && showOtpLayout">
                    <div class="container">
                        <p>Enter the 6-digit OTP sent to your <span *ngIf="normalNumber">phone</span><span *ngIf="!normalNumber">
                                <img class="mt-n1"
                                    src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/webiste-cms/1705044634332image%2084.png"></span>
                            <span> {{editMobileNumberString}}.&nbsp;</span><br><span (click)="redirectFromEditMobileNumber()" class="text-primary text-decoration-underline">
                                {{"Edit Mobile Number"}}</span>
                        </p>
                        <div class="otpInputStyling">
                            <aerp-base-schema-form [dataModel]="otpDataModel" [model]="otpModel" *ngIf="otpModel && otpFields" [layout]="otpFields"></aerp-base-schema-form>
                            <div class="resend-otp">
                                <ng-container *ngIf="timer >= 0 && timer!=60; else resendBlock">
                                    <p class="text-center text-dark mt-2">Request new code in <span class="text-primary">{{timer}}s
                                        </span></p>
                                </ng-container>
                                <ng-template #resendBlock>
                                    <p class="text-center text-primary text-decoration-underline fw-bold resend" (click)="sendOtp(mobileNumber)">Resend OTP
                                    </p>
                                </ng-template>
                            </div>
                        </div>

                        <button type="button" class="btn w-100 py-3 custom-btn-class ms-n2" [ngClass]="{'disabled btn-gray text-white':!otpModel?.otp,'btn-primary':otpModel?.otp}" (click)="submitOtp()">Continue <img src="../../../../assets/logo/next-icon-button.svg"
                                alt="nextIcon"></button>
                    </div>

                </ng-container>
            </div>
        </div>
    </div>

    <!-- mobile  -->
    <div class="d-lg-none d-block">

        <div *ngIf="step==='defaultForm'" class="container overflow-hidden" [ngClass]="{'mt-6':isPartnerLink && !partnerLogo}">
            <div *ngIf="!isPartnerLink" class="d-flex justify-content-center mb-2 py-4">
                <img class="img img-fluid" [width]="'200'" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1674329951680Group.png" alt="Education Loan">
            </div>

            <div *ngIf="isPartnerLink && partnerLogo" class="d-flex justify-content-center py-1 mt-1">
                <!-- hidden partner logo src -->
                <ng-container *ngIf="partnerLogo?.includes('public'); else privateLogo">
                    <img class="img img-fluid" width="100" [src]="partnerLogo" alt="Education Loan">
                </ng-container>
                <ng-template #privateLogo>
                    <fa-async-image [src]="partnerLogo" [width]="'100'"></fa-async-image>
                </ng-template>
            </div>

            <div class="mb-4">
                <h1 class="text-center text-primary-dark">Your Go-to Study Abroad Loan Expert </h1>
            </div>

            <div class="text-center mb-5">
                <div class="horizontal-scrolling-wrapper">
                    <div class="horizontal-scrolling-items" id="scrolling-items">
                        <div *ngFor="let bank of banks" class="horizontal-scrolling-items__item me-3">
                            <div class="d-flex justify-content-center align-items-center flex-column bankLogoDiv">
                                <img class="bankLogo" [src]="bank.logo" [alt]="bank.name">
                                <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715235236243Ellipse%20117.png" alt="">
                            </div>
                        </div>
                        <div *ngFor="let bank of banks" class="horizontal-scrolling-items__item me-3">
                            <div class="d-flex justify-content-center align-items-center flex-column bankLogoDiv">
                                <img class="bankLogo" [src]="bank.logo" [alt]="bank.name">
                                <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715235236243Ellipse%20117.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="margin-top-custom">
                    <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715231460452Stand%201.png" alt="">
                </div>
            </div>

            <div class="text-center mb-6">
                <p class="text-primary-dark fw-bold">4 steps to find your best loan.</p>
                <img class="img img-fluid" src="../../../../assets/logo/4steps.svg" alt="data-image" fetchPriority="low">
            </div>

            <div class="d-flex justify-content-center align-items-center flex-column mx-1">
                <button (click)="showFormLayout()" class="btn bg-primary-apply text-white rounded rounded-2 px-8 py-3 w-100 mb-3 fw-bold">Apply
                    Now</button>
                <p class="text-dark">Already Applied?
                    <span class="text-primary-dark mt-1 fw-bold" (click)="checkStatus()">Check
                        Status</span>
                </p>
            </div>
        </div>

        <div class="container overflow-hidden" *ngIf="step === 'selectLocationForm'">
            <div class="mb-8 overflow-hidden">
                <apnst-common-header [config]="configMobileNumberHeader" (stepEmitted)="emitStep($event)"></apnst-common-header>
            </div>
            <div class="container">
                <p class="text-gray">Where are you planning to study?</p>
                <button (click)="showIndianFormLayout()" class="btn border border-primary text-start p-3 fw-bold w-100 mb-2">In India</button>
                <button (click)="showNonIndianFormLayout()" class="btn border border-primary text-start p-3 fw-bold w-100">Abroad <span>(eg. USA, UK, Canada...)</span></button>
            </div>
        </div>


        <div *ngIf="step==='showForm'">
            <div class="mb-8 overflow-hidden">

                <apnst-common-header [config]="configMobileNumberHeader" (stepEmitted)="emitStep($event)"></apnst-common-header>
            </div>

            <div class="container layoutHeight d-flex justify-content-start flex-column">
                <div class="mb-3">
                    <aerp-base-schema-form [model]="model" [dataProcessor]="dataProcessor.bind(this)" [dataModel]="dataModel" (onSubmit)="onSubmit($event)" [layout]="layout">
                    </aerp-base-schema-form>
                    <div *ngIf="triggerErrorMessageMobile" class="text-danger">
                        {{errorMessageMobile}}
                    </div>
                    <div *ngIf="triggerErrorMessage" class="text-danger">
                        {{errorMessage}}
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="step==='showOtpForm'">
            <div class="mb-8 overflow-hidden">
                <apnst-common-header [config]="configOTPHeader" (stepEmitted)="emitStep($event)"></apnst-common-header>
            </div>
            <ng-container *ngIf="otpModel && otpFields && showOtpLayout">
                <div class="container">
                    <p>Enter the 6-digit OTP sent to your <span *ngIf="normalNumber">phone</span><span *ngIf="!normalNumber">
                            <img class="mt-n1"
                                src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/webiste-cms/1705044634332image%2084.png"></span>
                        <span> {{editMobileNumberString}}.&nbsp;</span><span (click)="redirectFromEditMobileNumber()" class="text-primary text-decoration-underline">
                            {{"Edit Mobile Number"}}</span>
                    </p>
                    <div class="otpInputStyling">
                        <aerp-base-schema-form [dataModel]="otpDataModel" [model]="otpModel" *ngIf="otpModel && otpFields" [layout]="otpFields"></aerp-base-schema-form>
                        <div class="resend-otp">
                            <ng-container *ngIf="timer >= 0 && timer!=60; else resendBlock">
                                <p class="text-center text-dark mt-2">Request new code in <span class="text-primary">{{timer}}s
                                    </span></p>
                            </ng-container>
                            <ng-template #resendBlock>
                                <p class="text-center text-primary text-decoration-underline fw-bold resend" (click)="sendOtp(mobileNumber)">Resend OTP
                                </p>
                            </ng-template>
                        </div>
                    </div>




                    <button type="button" class="btn  w-100 py-3 custom-btn-class" [ngClass]="{'disabled btn-gray text-white':!otpModel?.otp,'btn-primary':otpModel?.otp}" (click)="submitOtp()">Continue <img src="../../../../assets/logo/next-icon-button.svg"
                            alt="nextIcon"></button>
                </div>

            </ng-container>
        </div>

        <div class="d-flex justify-content-center align-items-center" *ngIf="step === 'notAbleToApplyForm'">
            <div class="mt-5 text-center container">
                <img class="img img-fluid mb-3" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1726487104450Frame%201000002048.png" alt="sorry">
                <h4 class="text-orange mb-3">Currently Unavailable</h4>
                <p class="fw-bold mb-3">We don’t offer loans for Indian institutions yet, but we’re working on it. Stay tuned!</p>

                <button (click)="goBackToLocationForm()" class="btn text-center bg-primary-apply text-start p-3 fw-bold w-100 mb-2">Go back</button>
            </div>
            
        </div>

    </div>


</div>



<ng-template #content let-modal>
    <div class="modal-body">
        <div class="text-end">
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="px-5 py-4">
            <div class="text-center text-primary-dark">
                <ng-container *ngIf="userType=='student'; else otherUser">
                    <h2 class="mb-2">Already Registered</h2>

                </ng-container>
                <p class="text-muted text-center">You are already registered with us. head over to www.foreignadmits.com and login with your credentials. </p>
                <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1675923623358side%20view%20of%20man%20standing%20with%20bicycle%20and%20looking%20at%20his%20phone.png" alt="Exisiting Application" class="img-fluid">
            </div>
        </div>
    </div>
    <div class="modal-footer px-4">
        <a target="_blank" href="https://www.foreignadmits.com/" class="btn btn-primary w-100" (click)="modal.close('Close click');">Login</a>
    </div>
</ng-template>



<ng-template #incorrectOtp>
    <div class="modal-body">
        <div class="d-flex justify-content-end fw-bold">
            <span class="cursor" (click)="modal.close('Close click');"><i class="bi bi-x-lg"></i></span>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center">
            <p class="fs-1 text-danger"><i class="bi bi-x-octagon-fill"></i></p>
            <h3 class="text-primary-dark">Incorrect OTP entered!</h3>
            <p class="text-primary">Please make sure you enter correct OTP</p>
        </div>
    </div>
</ng-template>